import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout.jsx'

// Core pages
import Home from './pages/Home.jsx'
import YouTubeDownloader from './pages/YouTubeDownloader.jsx'
import InstagramDownloader from './pages/InstagramDownloader.jsx'
import TikTokDownloader from './pages/TikTokDownloader.jsx'
import FacebookDownloader from './pages/FacebookDownloader.jsx'
import NotFound from './pages/NotFound.jsx'

// Info / legal pages
import Faqs from './pages/Faqs.jsx'
import About from './pages/About.jsx'
import Contact from './pages/Contact.jsx'
import Mail from './pages/Mail.jsx'
import Privacy from './pages/Privacy.jsx'
import Terms from './pages/Terms.jsx'
import Disclaimer from './pages/Disclaimer.jsx'
import Dmca from './pages/Dmca.jsx'

// SEO landing pages
import ExtractAudio from './pages/ExtractAudio.jsx'
import ConvertVideoToMp3 from './pages/ConvertVideoToMp3.jsx'
import ConvertWithoutSoftware from './pages/ConvertWithoutSoftware.jsx'
import MobileConvert from './pages/MobileConvert.jsx'

// Video downloader SEO pages
import YouTubeVideoDownloader  from './pages/YouTubeVideoDownloader.jsx'
import InstagramVideoDownloader from './pages/InstagramVideoDownloader.jsx'
import TikTokVideoDownloader   from './pages/TikTokVideoDownloader.jsx'
import FacebookVideoDownloader  from './pages/FacebookVideoDownloader.jsx'

// Admin pages (no Layout wrapper — standalone)
import AdminLogin     from './pages/admin/AdminLogin.jsx'
import AdminDashboard from './pages/admin/AdminDashboard.jsx'

// Dynamic SEO pages (created via admin panel)
import DynamicPage from './pages/admin/DynamicPage.jsx'

// Query page
import Query from './pages/Query.jsx'

// Guide pages (linked from Footer — must remain live routes)
import Mp3VsWav from './pages/Mp3VsWav.jsx'
import Blog from './pages/Blog.jsx'
import BlogPost from './pages/BlogPost.jsx'
import ContentPage from './pages/ContentPage.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* ── Core ────────────────────────────────── */}
        <Route index element={<Home />} />
        <Route path="youtube-downloader"   element={<YouTubeDownloader />} />
        <Route path="instagram-downloader" element={<InstagramDownloader />} />
        <Route path="tiktok-downloader"    element={<TikTokDownloader />} />
        <Route path="facebook-downloader"  element={<FacebookDownloader />} />

        {/* ── Info / legal ────────────────────────── */}
        <Route path="faqs"          element={<Faqs />} />
        <Route path="about"         element={<About />} />
        <Route path="contact"       element={<Contact />} />
        <Route path="mail"          element={<Mail />} />
        <Route path="privacy"       element={<Privacy />} />
        {/* alias — Footer links to /privacy-policy */}
        <Route path="privacy-policy" element={<Privacy />} />
        <Route path="terms"         element={<Terms />} />
        <Route path="disclaimer"    element={<Disclaimer />} />
        <Route path="dmca"          element={<Dmca />} />

        {/* ── SEO landing pages ───────────────────── */}
        <Route path="extract-audio"            element={<ExtractAudio />} />
        <Route path="convert-video-to-mp3"     element={<ConvertVideoToMp3 />} />
        <Route path="convert-without-software" element={<ConvertWithoutSoftware />} />
        <Route path="mobile-convert"           element={<MobileConvert />} />

        {/* ── Video downloader SEO pages ─────────── */}
        <Route path="youtube-video-downloader"   element={<YouTubeVideoDownloader />} />
        <Route path="instagram-video-downloader" element={<InstagramVideoDownloader />} />
        <Route path="tiktok-video-downloader"    element={<TikTokVideoDownloader />} />
        <Route path="facebook-video-downloader"  element={<FacebookVideoDownloader />} />

        {/* ── Query ───────────────────────────────── */}
        <Route path="query" element={<Query />} />

        {/* ── Guide pages (linked from Footer) ────── */}
        <Route path="mp3-vs-wav" element={<Mp3VsWav />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="info/:slug" element={<ContentPage />} />

        {/* ── Dynamic pages (admin-created) ───────── */}
        <Route path="p/:slug" element={<DynamicPage />} />

        {/* ── Catch-all ───────────────────────────── */}
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* ── Admin (no shared Layout) ─────────────── */}
      <Route path="admin"           element={<AdminLogin />} />
      <Route path="admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  )
}
